import { Stack, useLocalSearchParams } from 'expo-router';
import React from 'react';
import { Platform, View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { useCustomer } from '@/api/customers/use-customer';
import type { Reservation } from '@/api/reservations/types';
import { useReservation } from '@/api/reservations/use-reservation';
import BackButton from '@/components/back-button';
import { RentalAgreementView } from '@/components/rental-agreement';
import { downloadRentalAgreementPdf } from '@/components/rental-agreement-pdf';
import { isDesktop } from '@/core';
import { Loader } from '@/ui/loader';

export default function RentalAgreement() {
  const { theme } = useStyles();
  const { id } = useLocalSearchParams<{ id: string }>();

  const [isGeneratingPdf, setIsGeneratingPdf] = React.useState(false);

  const { data: customer } = useCustomer({});

  const { data: resData, isPending: isFetchingReservation } = useReservation({
    //@ts-ignore
    variables: { id },
    enabled: !!id,
  });

  const canDownloadPdf =
    isDesktop() &&
    Platform.OS === 'web' &&
    !!resData &&
    (customer?.email?.toLowerCase().endsWith('@eonrides.com') ||
      customer?.email?.toLowerCase().endsWith('@teslarents.com'));

  async function handleDownloadPdf() {
    setIsGeneratingPdf(true);
    await downloadRentalAgreementPdf(resData as Reservation);
    setIsGeneratingPdf(false);
  }

  if (isFetchingReservation) {
    return (
      <View
        style={{
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: theme.colors.background_1,
        }}
      >
        <Loader style={{ height: 150, width: 150 }} />
      </View>
    );
  }

  return (
    <>
      {isDesktop() && Platform.OS === 'web' ? (
        <Stack.Screen options={{ headerShown: false }} />
      ) : (
        <Stack.Screen
          options={{
            title: 'Rental Agreement',
            headerTitle: 'Rental Agreement',
            headerLeft: () => <BackButton />,
            headerShown: true,
            headerStyle: { backgroundColor: theme.colors.background_1 },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
          }}
        />
      )}

      <RentalAgreementView
        resData={resData as Reservation}
        resId={id}
        onDownloadPdf={canDownloadPdf ? handleDownloadPdf : undefined}
        isGeneratingPdf={isGeneratingPdf}
      />
    </>
  );
}
